export default __webpack_public_path__ + "static/media/close-cross-blue.b208dbe1.svg";